import { Container, Theme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import useMediaQuery from '@mui/material/useMediaQuery'

import Button from '@/components/atoms/Button'
import ModalHeader from '@/components/molecules/ModalHeader'
import WishItem from '@/components/molecules/WishItem'
import LeafsIcon from 'public/images/leafs.svg'

import ComponentStyled from './styled'

type Props = {
  onConfirm: () => void
  user: string
  avatar: string
  wish: string
  location: string
}

const WishPreview = ({ onConfirm, user, avatar, wish, location }: Props): JSX.Element => {
  const { t } = useTranslation()
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'))

  return (
    <ComponentStyled>
      <Container maxWidth='xl'>
        <div className='wish-preview-box'>
          <ModalHeader
            prepend={t('Step 3')}
            title={t('wish Preview')}
            description={t('This is how your wish will be published:')}
          />
          <div className='wish-preview-content'>
            <div className='wish-wrapper'>
              <WishItem username={user} avatar={avatar} comment={wish} location={location} />
            </div>

            <div className='next-btn-wrapper'>
              <Button
                fitToContainer={isMobile}
                size='medium'
                label={t('Plant your wish')}
                icon={<LeafsIcon />}
                onClick={onConfirm}
              />
            </div>
          </div>
        </div>
      </Container>
    </ComponentStyled>
  )
}

export default WishPreview
